import React from "react";
import "./style.css";
import { connect } from "react-redux";
import { CHAKBOX_LIST } from "../../constant";
import { isChoiceSelected } from "../../utils/vehicleDetails";

function InputTypes(props) {
  const { inp_chk_action, data, divindex, index_of, embedded } = props;

  const Chkboxvaluehandler = (e, event) => {
    if (event.target.checked) {
      let feature = [];
      if (divindex[index_of]) {
        feature = divindex[index_of];
      }
      inp_chk_action({
        div: [...feature, e.choice_id],
        index: index_of,
      });
    } else {
      const feature = divindex[index_of];
      if (!feature) return;
      const idx = feature.indexOf(e.choice_id);
      if (idx !== -1) {
        const next = [...feature];
        next.splice(idx, 1);
        inp_chk_action({
          info: next,
          div: next,
          index: index_of,
        });
      }
    }
  };

  const inpboxvaluehandler = (e) => {
    const d = [e.choice_id];
    inp_chk_action({
      info: d,
      div: d,
      index: index_of,
    });
  };

  const choices = data?.choices ?? [];
  const isSingleSelect = data?.select == "1";
  const hint = isSingleSelect
    ? "Select one from the following"
    : "Choose all that apply to your car";

  const renderChoices = () => {
    if (!choices.length) {
      return (
        <p className="pi-vehicle-wizard__empty-options">
          Options for this question are not available yet. Go back and save the
          previous answer, or continue with Next.
        </p>
      );
    }

    return choices.map((item) => {
      const selected = isChoiceSelected(divindex, index_of, item.choice_id);

      if (isSingleSelect) {
        return (
          <button
            key={item.choice_id}
            type="button"
            className={`pi-car-update__choice ${selected ? "is-selected" : ""}`}
            aria-pressed={selected}
            onClick={() => inpboxvaluehandler(item)}
          >
            {item.name}
          </button>
        );
      }

      return (
        <label
          key={item.choice_id}
          className={`pi-car-update__check ${selected ? "is-selected" : ""}`}
        >
          <input
            type="checkbox"
            checked={selected}
            onChange={(event) => Chkboxvaluehandler(item, event)}
          />
          <span className="pi-car-update__check-box" aria-hidden />
          <span className="pi-car-update__check-label">{item.name}</span>
        </label>
      );
    });
  };

  if (embedded) {
    return (
      <div
        className={`pi-car-update__choices pi-vehicle-wizard__choices ${
          isSingleSelect ? "pi-car-update__choices--single" : "pi-car-update__choices--multi"
        }`}
      >
        {renderChoices()}
      </div>
    );
  }

  return (
    <div className="pi-car-update__question">
      <div className="pi-car-update__question-head">
        <p className="pi-car-update__eyebrow">Question {props.stepMeta ?? index_of + 1}</p>
        <h2 className="pi-car-update__question-title">{data["question"]}</h2>
        <p className="pi-car-update__question-lead">{hint}</p>
      </div>

      <div
        className={`pi-car-update__choices ${
          isSingleSelect ? "pi-car-update__choices--single" : "pi-car-update__choices--multi"
        }`}
      >
        {renderChoices()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  divindex: state.cardeailupdate.divindex,
});

const mapDispatchToProps = (dispatch) => ({
  inp_chk_action: (data) =>
    dispatch({
      type: CHAKBOX_LIST,
      payload: {
        data,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(InputTypes);
